// 角色設定 modal 的功能權限目錄（role.jsp ruleSettingModal #permissionTable）。
//
// legacy 欄位（role.jsp:10-40 permissionColumn）：
//   模組(groupDisplay)／程式名稱(name)／權限(查詢 ACCESS)／權限(編輯 UPDATE)／
//   權限(刪除 DELETE)／權限(匯出 EXPORT)——每格是一顆 checkbox，value 是該權限的 id，
//   勾選集合經 `config/saveRolePermissionAjax {roleId, permissionIds[]}` 存回。
// 目錄資料來源 legacy＝`config/gePermissionListAjax`（DB Permission 表，全站功能清單）。
//
// 雛形沒有 DB：以 legacy「快速選單」實測的功能清單（contract `config-role` 頁的
// 快速選單 modal 按鈕序列）為種子目錄，權限 id 用確定性規則產生（`${name}#${op}`）。
// 【雛形值待實機校準】：真實 id／分群（groupDisplay）要等接上真 API 後校準。

export interface RolePermissionEntry {
  /** 權限 id（勾選值；legacy 是 DB 自增 id，雛形用確定性字串 id）。 */
  readonly id: string;
  /** 模組（legacy groupDisplay）。 */
  readonly group: string;
  /** 程式名稱（legacy name）。 */
  readonly name: string;
}

/** 種子目錄的模組清單（快速選單系統資料管理相關功能，legacy 快速選單按鈕文字逐字）。 */
const MODULE_NAMES: readonly string[] = [
  '系統參數',
  '訊息通知',
  '登入紀錄',
  '異動紀錄',
  '訓練類別部門維護',
  '訓練類別設定',
  '角色及權限維護',
  '設備維護',
  '地點維護',
  '年度維護',
  '職稱維護',
  '部門維護',
  '組織維護',
  '帳號維護',
  '常用語管理',
  '留言板',
  '留言類別管理',
  '開課管理',
  '課程查詢',
  '題庫管理',
  '請假單',
  '公告',
];

/** 種子目錄：每個模組一列（name＝模組名，legacy 多數模組一個程式一列）。 */
export const ROLE_PERMISSION_CATALOG: readonly RolePermissionEntry[] = MODULE_NAMES.map((name) => ({
  id: `perm:${name}`,
  group: '系統資料管理',
  name,
}));

/** 權限四欄的定義（role.jsp permissionColumn 的資料欄與 checkbox 文字）。 */
export const ROLE_PERMISSION_KINDS: readonly { readonly key: string; readonly label: string }[] = [
  { key: 'ACCESS', label: '權限(查詢)' },
  { key: 'UPDATE', label: '權限(編輯)' },
  { key: 'DELETE', label: '權限(刪除)' },
  { key: 'EXPORT', label: '權限(匯出)' },
];

/** 某個目錄列在某個權限欄的勾選值 id（legacy 每格是獨立的 Permission id）。 */
export function permissionCellId(entry: RolePermissionEntry, kindKey: string): string {
  return `${entry.id}#${kindKey}`;
}

/** role.jsp:19-23：學員角色看到的「測驗查詢」要顯示成「線上測驗」（特殊改名規則）。 */
export function permissionDisplayName(name: string, roleName: string): string {
  return name === '測驗查詢' && roleName === '學員' ? '線上測驗' : name;
}
